import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useEcusDiagStore = defineStore('ecus-diag', () => {

    const configStore   = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    const diag                  = ref({})
    const diagProcess           = ref(false)
    const diagMsg               = ref({})
    const diagDeleteProcess     = ref(false)
    const diagDeleteMsg         = ref({})
    const diagFile              = ref('')
    const diagFileProcess       = ref(false)
    const diagFileMsg           = ref({})
    const reports               = ref({})
    const reportsProcess        = ref(false)
    const reportsMsg            = ref({})
    const diagRunProcess        = ref(false)
    const diagRunMsg            = ref({})
    const diagDeleteDTCProcess  = ref(false)
    const diagDeleteDTCMsg      = ref({})

    /**
     * Получает информацию о последних файлах отчёта по ЭБУ выбранного автомобиля
     * 
     * @param {Object} payload - не надо сюда смотреть; смотреть надо в свагер! и не забыть забрать его с нового протника... а не как в прошлый раз
     */
    async function readDiag(payload) {

        diagProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    if(param !== 'vin') {
                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/reports/${payload.vin}${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                diag.value = request.lastReport
                diagMsg.value = { success: true }
            } else {
                diagMsg.value = { success: false, text: request.error }
            }

        } else {
            diagMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        diagProcess.value = false
    }

    /**
     * Получает содержимое файла PDF для диагностики или отправляет файл на e-mail
     * 
     * @param {Object} payload - см.swager
     */
    async function readDiagFile(payload) {

        diagFileProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    if(param !== 'uuid') {
                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/reports/${payload.uuid}/file.pdf${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {
                diagFile.value = request
                diagFileMsg.value = { success: true }
                diagFileMsg.value.text = 
                    payload.email ? 
                        'DIAG_IMPORT_EMAIL_SUCCESS' : 
                        'DIAG_IMPORT_FILE_SUCCESS'
            } else {
                diagFileMsg.value = { success: false, text: request.error}
            }

        } else {
            diagFileMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        diagFileProcess.value = false
    }

    /**
     * Запуск диагностики ЭБУ выбранного автомобиля
     * 
     * @param {Object} payload - { uuid: UUID_автомобиля, diag: { ecu: "ИМЯ_БЛОКА" } } }
     */
    async function runDiag(payload) {

        diagRunProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/command/execute`, 
                method: 'POST', 
                data: payload, 
                token
            })

            if(!request.error) {
                diagRunMsg.value = { success: true, text: 'ECUS_DIAG_REFRESH_SUCCESS' }
            } else {
                diagRunMsg.value = { success: false, text: request.error }
            }

        } else {
            diagRunMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        diagRunProcess.value = false
    }

    /**
     * Удаляет диагностические отчеты ЭБУ автомобиля
     * 
     * @param {Object} payload - { vin: VIN-код_автомобиля , name: название_файла_отчета__DTC_timestamp_blockName }
     */
    async function deleteDiag(payload) {

        diagDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/reports/${payload.vin}/${payload.name}`, 
                method: 'DELETE', 
                token,
                data: payload
            })

            if(!request.error) {
                diagDeleteMsg.value = { success: true, text: 'DIAG_BLOCK_DELETE_SUCCESS' }
            } else {
                diagDeleteMsg.value = { success: false, text: request.error }
            }
            
        } else {
            diagDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        diagDeleteProcess.value = false
    }

    /**
     * Получает список отчетов ЭБУ автомобиля
     * 
     * @param {String} payload - параметры запроса [см.swagger]
     */
    async function readReports(payload) {

        reportsProcess.value = true
        const token = tokenStore.access

        if (token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/reports${params}`,
                method: 'GET',
                token
            })

            if (!request.error) {
                reports.value = request
                reportsMsg.value = { success: true } 
            } else {
                reportsMsg.value = { success: false, text: request.error }
            }

        } else {
            reportsMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        reportsProcess.value = false
        return reports.value
    }

    /**
     * Удаляет коды ошибок по ЭБУ автомобиля
     * 
     * @param {Object} payload - { vin: VIN_автомобиля , name: имя_блока }
     */
    async function deleteDiagDTC(payload) {

        diagDeleteDTCProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/command/execute`, 
                method: 'POST', 
                data: payload,
                token
            })

            if(!request.error) {
                diagDeleteDTCMsg.value = { success: true, text: 'CMD_SUCCESS' }
            } else {
                diagDeleteDTCMsg.value = { success: false, text: request.error}
            }

        } else {
            diagDeleteDTCMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        diagDeleteDTCProcess.value = false
    }
    
    const setDiag               = data => diag.value             = data
    const setDiagMsg            = data => diagMsg.value          = data
    const setDiagRunMsg         = data => diagRunMsg.value       = data
    const setDiagFileMsg        = data => diagFileMsg.value      = data
    const setDiagDeleteMsg      = data => diagDeleteMsg.value    = data
    const setReports            = data => reports.value          = data
    const setReportsMsg         = data => reportsMsg.value       = data
    const setDiagDeleteDTCMsg   = data => diagDeleteDTCMsg.value = data

    return {

        diag,
        diagProcess,
        diagMsg,
        diagDeleteProcess,
        diagDeleteMsg,
        diagFile,
        diagFileProcess,
        diagFileMsg,
        reports,
        reportsProcess,
        reportsMsg,
        diagRunProcess,
        diagRunMsg,
        diagDeleteDTCProcess,
        diagDeleteDTCMsg, 
        readDiag,
        readDiagFile,
        runDiag,
        deleteDiag,
        readReports,
        deleteDiagDTC,
        setDiag,
        setDiagMsg,
        setDiagRunMsg,
        setDiagFileMsg,
        setDiagDeleteMsg,
        setReports,
        setReportsMsg,
        setDiagDeleteDTCMsg
    }
})
